// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_he-a";
export var fulfillmentFormRail = "_he-9";
export var headerTitleRow = "_he-c";
export var orderDetailsWrapper = "_he-7";
export var orderLinkTrigger = "_he-2";
export var paymentInformationGrid = "_he-h";
export var paymentSummaryColumn = "_he-i";
export var shipmentContainer = "_he-b";
export var shipmentDetailsMainPane = "_he-8";
export var shipmentNavigationCard = "_he-5";
export var shipmentNavigationRail = "_he-3";
export var shipmentNavigationRailHeader = "_he-4";
export var shipmentSummaryFact = "_he-e";
export var shipmentSummaryGrid = "_he-d";
export var shipmentSummaryMetadataRow = "_he-f";
export var shipmentSummaryTags = "_he-g";
export var shipmentWorkspace = "_he-0";
export var shipmentWorkspaceContent = "_he-6";
export var shipmentWorkspaceHeader = "_he-1";